import { useNavigate } from 'react-router-dom';
import Button from './Button';

interface TitleNumberCardProps {
  title: string;
  number: number | string;
  buttonText?: string;
  buttonLink?: string;
}

const TitleNumberCard = ({
  title, number, buttonText, buttonLink,
}: TitleNumberCardProps) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (buttonLink) {
      navigate(buttonLink);
    }
  };
  return (
    <div className="flex flex-col align-start self-stretch bg-blur-md bg-opacity-heavy border border-border-secondary shadow rounded-3xl">
      <div className="flex py-4 px-8 flex-col align-start self-stretch gap-4">
        <h1 className="flex-1 font-medium text-base text-text-primary">{title}</h1>
      <p className="flex-1 font-semibold text-4xl text-text-primary">{number}</p>
    </div>
    {buttonText && buttonLink && (
      <div className="flex p-2 flex-col items-end self-stretch border-t border-border-secondary">
        <div className="flex justify-center items-center ">
          <Button variant="tertiary" onClick={() => handleClick()}>{buttonText}</Button>
        </div>
      </div>
    )}
    </div>
  );
};

export default TitleNumberCard;
